(() => {
  const setAmount = (el, formatted) => {
    if (!el) return;
    const sr = el.querySelector(".sr-only");
    // Money formats may contain app markup; insert only the parsed text.
    const text = new DOMParser().parseFromString(formatted, "text/html").body.textContent.trim();
    el.replaceChildren(...(sr ? [sr, text] : [text]));
  };

  const updateCardPrice = (card, input) => {
    const list = card.querySelector("price-list");
    if (!list) return;
    const formatted = input.getAttribute("data-variant-price-formatted");
    if (!formatted) return;
    const price = Number(input.getAttribute("data-variant-price"));
    const compare = Number(input.getAttribute("data-variant-compare-at-price") || 0);
    const onSale = Number.isFinite(price) && Number.isFinite(compare) && compare > price;
    const sale = list.querySelector("sale-price");
    if (!sale) return;

    sale.className = onSale
      ? list.getAttribute("data-on-sale-price-class") || sale.className
      : list.getAttribute("data-regular-price-class") || sale.className;
    setAmount(sale, formatted);

    let compareEl = list.querySelector("compare-at-price");
    if (onSale) {
      const compareFormatted = input.getAttribute("data-variant-compare-at-formatted") || "";
      if (!compareEl) {
        compareEl = document.createElement("compare-at-price");
        compareEl.className = list.getAttribute("data-compare-at-price-class") || "text-subdued line-through";
        const sr = document.createElement("span");
        sr.className = "sr-only";
        sr.textContent = list.getAttribute("data-regular-price-label") || "";
        compareEl.append(sr);
        sale.after(compareEl);
      }
      setAmount(compareEl, compareFormatted);
    } else {
      compareEl?.remove();
    }
  };

  // B4B clones cards without firing a swatch change event.
  const syncedBadges = new WeakMap();
  const syncB4BBadges = () => {
    document.querySelectorAll("product-card.variable-products[data-variant-id]").forEach((card) => {
      const badge = card.querySelector("[data-card-variant-availability]");
      if (!badge || syncedBadges.get(badge) === card.dataset.variantId) return;
      const available = JSON.parse(badge.getAttribute("data-card-variant-availability"))[card.dataset.variantId];
      if (typeof available !== "boolean") return;
      if (badge.hidden !== available) badge.hidden = available;
      syncedBadges.set(badge, card.dataset.variantId);
    });
  };

  let badgeFrame;
  window.addEventListener("b4bVariantsDisplayed", () => {
    cancelAnimationFrame(badgeFrame);
    badgeFrame = requestAnimationFrame(syncB4BBadges);
  });
  syncB4BBadges();

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== "radio") return;
    if (!target.hasAttribute("data-variant-price-formatted")) return;
    const card = target.closest("product-card");
    if (!card) return;
    if (target.hasAttribute("data-variant-available")) {
      const badge = card.querySelector("[data-card-sold-out-badge]");
      if (badge) badge.hidden = target.getAttribute("data-variant-available") === "true";
    }
    updateCardPrice(card, target);
  });
})();
